
export const APP_HOST = process.env.REACT_APP_HOST?.slice(0, -1) as string
export const PORT_CENTURY = process.env.REACT_APP_CENTURY
export const PORT_MOVIMIENTO = process.env.REACT_APP_MOVIMIENTO
